<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
/>

<header>
  <div class="header">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="image-logo">
        <a class="navbar-brand" routerLink="/">
          <img src="/assets/icon/icon-logo-shell.svg" class="logo-shell" alt="Logo Shell Box" />
        </a>
      </div>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <a class="nav-item nav-link" routerLink="/programa" routerLinkActive="active">Programa Shell Box</a>
          <a class="nav-item nav-link" routerLink="/app" routerLinkActive="active">App Shell Box</a>
          <a class="nav-item nav-link" routerLink="/beneficios-y-descuentos" routerLinkActive="active">Beneficios</a>
          <a class="nav-item nav-link" [href]="urlMktplace">Market Shell</a>
        </div>
      </div>

      <div *ngIf="!guestUser" class="buttons-container">
        <div class="profile-info">
          <div class="box">
            <span class="header-puntos">{{ userBalance }} puntos</span>
          </div>
          <div class="user-icon">
            <div id="dropdownMenuButton" role="button" data-bs-toggle="dropdown" aria-haspopup="true">
              <span>{{ userInitials }}</span>
            </div>      
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [ngClass]="{ 'border-none': !isMobile }">
              <div class="slider-menu" [ngClass]="{ 'desktop-menu': !isMobile }">
                <button *ngIf="isMobile" class="close-menu" (click)="closeMenuMobile()">
                  <img src="../../../../assets/icon/icon-close-menu.svg" alt="Cerrar menú" />
                </button>
                <div class="user-description" [ngClass]="{ 'desktop-description': !isMobile }">
                  <div id="dropdownMenuButton" role="button" data-bs-toggle="dropdown" aria-haspopup="true" class="first-letter">
                    <span>{{ userInitials }}</span>
                  </div> 
                  <div *ngIf="isMobile" class="points-user">
                    <span>{{ userBalance }} puntos</span>
                  </div>
                  <span class="user-name">¡Hola, {{this.currentUser.person.profile.firstname}}!</span>
                </div>
                <nav class="header-buttons" role="menu">
                  <a *ngFor="let option of option" routerLink="{{ option.url }}" routerLinkActive="active">
                    {{ option.label }}
                  </a>
                  <div *ngIf="!guestUser" class="sign-out">
                    <img src="../../../../assets/icon/icon-close-session.svg" alt="Cerrar sesión">
                    <a href="#" (click)="logout()">Cerrar Sesión</a>
                  </div>
                </nav>  
              </div>
            </div>     
          </div>
          <img id="loginMobile" src="../../../../assets/icon/icon-hamburguer-menu.svg" class="burger" alt="Menú móvil" (click)="showMenuMobile()" />
          <div class="box-mobile">
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" routerLink="/perfil">Mi Perfil</a>
              <a class="dropdown-item" routerLink="/conversor">Conversor de Puntos</a>
              <a class="dropdown-item" routerLink="/historial">Histórico de Puntos</a>
              <a class="dropdown-item" routerLink="/historial-sorteos">Histórico de Sorteos</a>
              <a class="dropdown-item" href="#" (click)="logout()">Cerrar Sesión</a>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="guestUser" class="buttons-container">
        <div class="profile-info">
          <button
            [ngClass]="{ 'mobile-login': isMobile, 'desktop-login': !isMobile }"
            type="button"
            id="btnHeaderRegistro"
            (click)="isMobile ? openLogin() : onRegistrarmeClick()">
            <span class="icon">
              <img src="../../../../assets/icon/icon-signin-mobile.svg" alt="Iniciar sesión" />
            </span>
          </button>        
          <img 
            id="loginMobile" 
            src="../../../../assets/icon/icon-hamburguer-menu.svg" 
            class="burger" 
            alt="Menú móvil"
            (click)="showMenuMobile()" />
          <button class="btn btn-primary btn-login" id="loginDesktop" (click)="openLogin()">
            Ingresar
          </button>
        </div>
      </div>
    </nav>
  </div>
</header>

<div [ngClass]="menuMobileVisible ? 'show side-menu' : 'not-show'">
  <div class="slider-menu menu-options" [ngClass]="menuMobileVisible ? 'show' : 'not-show'">
    <button class="close-menu" (click)="closeMenuMobile()">
      <img src="../../../../assets/icon/icon-close-menu.svg" alt="Cerrar menú" />
    </button>
    <div class="brand-header">
      <img src="../../../../assets/icon/icon-logo-shell.svg" class="brand-menu" alt="Shell Logo" />
    </div>
    <nav class="header-buttons" role="menu">
      <a *ngFor="let link of links" [routerLink]="link.url" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenuMobile()">
        {{ link.label }}
      </a>
    </nav>  
  </div>
</div>
<app-login [isModal]="true"></app-login>
<app-register [isModal]="true"></app-register>
